import { usePlanIsSecret as useIsSecret } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-secret/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanIsSecret = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { isPrivate: isSecret, hotelID } = viewModel;

	return {
		...useIsSecret({
			isSecret,
			onSetViewModel,
		}),
		hotelID,
	};
};
